<template>
    <div class="content3-card">
      <div class="card-content">
        <slot name="cardItem"></slot>
      </div>
      <slot name="halfMoonUp" :half-moon-up-path="card.halfMoonUpPath"></slot>
      <slot name="halfMoonDown" :half-moon-down-path="card.halfMoonDownPath"></slot>
    </div>
</template>


<script>
  export default {
    name: "content3-card",
    props: ["view"],
    components: {},
    data() {
      return {
        content: [],
        halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
        halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
      }
    },

    computed: {
      card: function () {
          return (this.view !== undefined && this.view !== null) ? this.view : this.$data
      }
    },

    created() {},
    mounted() {},

    methods: {}
  };
</script>
<style lang="scss">
  @import "../../../../../scss/office";

    .of-content3-item ~ .of-content3-item{
        border-top: 0.5px $of-color20 solid;
    }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../../../../scss/office";

    .content3-card{
      font: inherit;
      background-color: $of-color3;
      position: relative;

      .card-content{
        font: inherit;
        position: relative;
        width: 100%;
        height: 100%;

        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: stretch;
        justify-content: stretch;
        align-content: stretch;
      }
    }

    .content3-card:first-child{
      font: inherit;
      border-radius: 0.4em 0.4em 0 0; /* 4px 4px 0 0  */

      .half-moon-up{
        display: none;
      }
    }
    .content3-card:last-child{
      font: inherit;
      border-radius: 0 0 0.4em 0.4em; /* 0 0 4px 4px */

      .half-moon-down{
        display: none;
      }
    }


    .content3-card:not(:first-child){
      font: inherit;
      padding-top: 2.6em; /* 50px */

      .half-moon-up{
        font: inherit;
        width: 5em; /*50px*/
        height: auto;

        position: absolute;
        left: 18.7704918%; /*229px*/
        top: -0.2em; /*2px*/

        transform: rotate(180deg);
      }
    }
    .content3-card:not(:last-child){
      font: inherit;
      padding-bottom: 2.6em; /* 50px */

      .half-moon-down{
        font: inherit;
        width: 5em; /*50px*/
        height: auto;

        position: absolute;
        right: 18.7704918%; /*229px*/
        bottom: -0.2em; /*2px*/
      }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-3/card.vue